import { render, staticRenderFns } from "./ViewSubCompany.vue?vue&type=template&id=1718349f&scoped=true"
import script from "./ViewSubCompany.vue?vue&type=script&lang=js"
export * from "./ViewSubCompany.vue?vue&type=script&lang=js"
import style0 from "./ViewSubCompany.vue?vue&type=style&index=0&id=1718349f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1718349f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1718349f')) {
      api.createRecord('1718349f', component.options)
    } else {
      api.reload('1718349f', component.options)
    }
    module.hot.accept("./ViewSubCompany.vue?vue&type=template&id=1718349f&scoped=true", function () {
      api.rerender('1718349f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/ViewSubCompany.vue"
export default component.exports